module.exports = __webpack_public_path__ + "552d6c295e94301f9fcbbb575b0b8fa9.svg";